import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { TopCiudadesResumen } from 'src/app/models/generic/TopCiudadesResumen';
import { ApexAxisChartSeries, ApexChart, ChartComponent, ApexDataLabels, ApexXAxis, ApexPlotOptions, ApexTitleSubtitle } from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[],
  stroke: ApexStroke,
  title: ApexTitleSubtitle,
  subtitle: ApexTitleSubtitle,
  tooltip: ApexTooltip
};

@Component({
  selector: 'globalciudades',
  templateUrl: './globalciudades.component.html',
  styleUrls: ['./globalciudades.component.scss']
})
export class GlobalciudadesComponent implements OnInit{
  mostrarCargando: boolean = true;
  cantidadMaxima: number = 0;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {
      this.RecargarGrafica();
    }

  ngOnInit() {
    if (this.autenticacionService.EstaAutenticado()) {
      this.cargarResumen();

      this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
        if (cambiarResumen) {
          this.cargarResumen();
        }
      });
    }
  }

  cargarResumen() {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.productosService.CargarTopCiudadesResumen(parametrosConsulta.value).subscribe((resp: TopCiudadesResumen[]) => {
      this.productosService.ListaTopCiudadesResumen = resp;
      for (let index = 0; index < this.productosService.ListaTopCiudadesResumen.length; index++) {
        if (this.productosService.ListaTopCiudadesResumen[index].cantidad >= this.cantidadMaxima) {
          this.cantidadMaxima = this.productosService.ListaTopCiudadesResumen[index].cantidad;
        }
      }
      this.RecargarGrafica();
      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  ObtenerPorcentajeResumen(item: TopCiudadesResumen): string {
    let porcentaje: number = (((item.cantidad*100)/this.cantidadMaxima)/100);
    return `--size:${porcentaje}; --color: #bf0d3e;`;
  }
  RecargarGrafica() {
    let listData: number [] = [];
    let listLabels: string [] = [];
    if (this.utilitariosService.VerificarContieneDatos(this.productosService.ListaTopCiudadesResumen)) {
      for (let index = 0; index < this.productosService.ListaTopCiudadesResumen.length; index++) {
        listData.push(this.productosService.ListaTopCiudadesResumen[index].cantidad);
        listLabels.push(this.productosService.ListaTopCiudadesResumen[index].ciudad);
      }
    }

    this.chartOptions = {
      series: [{
      data: listData
    }],
      chart: {
      type: 'bar',
      height: 380,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: false,
        horizontal: true,
        dataLabels: {
          position: 'bottom'
        },
      }
    },
    colors: ['#bf0d3e'],
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        colors: ['#000']
      },
      formatter: function (val, opt) {
        return `${val}`
      },
      offsetX: 0,
      dropShadow: {
        enabled: false
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: listLabels,
      labels: {
        show: true
      }
    },
    yaxis: {
      labels: {
        show: true
      }
    },
    title: {
        text: '',
        align: 'center',
        floating: false
    },
    subtitle: {
        text: '',
        align: 'center',
    },
    tooltip: {
      theme: 'dark',
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function () {
            return ''
          }
        }
      }
    }
    };
  }
}
